import { ValueOf } from '../../../types/common/utils';

export const DATE_RANGE_TYPE = {
  /**
   *  직접 설정
   */
  DIRECT_SETTING: 0,
  /**
   *  무기한
   */
  INFINITE: 1,
} as const;
export type DATE_RANGE_TYPE = ValueOf<typeof DATE_RANGE_TYPE>;

export const DATE_RANGE_TYPE_SELECT_LIST = [
  {
    id: DATE_RANGE_TYPE.DIRECT_SETTING,
    name: '직접 설정',
  },
  {
    id: DATE_RANGE_TYPE.INFINITE,
    name: '무기한',
  },
];

/**
 *  날짜 포맷
 */
export const DATE_FORMAT = {
  YMD_KOREAN_FORMAT: 'YYYY년 MM월 DD일',
  FULL_DASH_FORMAT: 'YYYY-MM-DD HH:mm:ss',
  YMD_DASH_FORMAT: 'YYYY-MM-DD',
  UTC_FORMAT: 'YYYY-MM-DD"T"HH:mm:ss.SSS"Z"',
  YMD_HM_DOT_FORMAT: 'YYYY.MM.DD HH:mm',
  YMD_HM_DASH_FORMAT: 'YYYY-MM-DD HH:mm',
} as const;
